import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

const BackToTopButton = ({ pageData, viewMode, onToggleViewMode }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 20) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleClick = () => {
    // For Book 3 and Book 4 in expanded mode, toggle to compressed mode
    if ((pageData === 'rfm3' || pageData === 'ultimate' || pageData === 'ultimate2') && viewMode === 'expanded') {
      onToggleViewMode();
    } else {
      // Default behavior: scroll to top
      scrollToTop();
    }
  };

  if (!isVisible) return null;

  // For Book 3 and Book 4 in expanded mode, show compress button
  const isCompressButton = (pageData === 'rfm3' || pageData === 'ultimate' || pageData === 'ultimate2') && viewMode === 'expanded';

  return (
    <Button
      onClick={handleClick}
      style={{
        position: "fixed",
        bottom: "20px",
        right: "max(calc((100% - 1140px) / 2 + 20px), 20px)",
        zIndex: 1000,
        borderRadius: isCompressButton ? "20px" : "50%",
        width: isCompressButton ? "auto" : "50px",
        height: "50px",
        padding: isCompressButton ? "0 15px" : 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: isCompressButton ? "bold" : "normal",
        fontSize: isCompressButton ? "14px" : "inherit"
      }}
      variant={isCompressButton ? "warning" : "primary"}
    >
      {isCompressButton ? "Compress" : <FontAwesomeIcon icon={faArrowUp} />}
    </Button>
  );
};

export default BackToTopButton;
